<template>
  <div class="container">
    <div class="before-you-go-container">
      <span class="before-you-go">
        Before you go, consider these special offers:
      </span>
    </div>
    <div class="row">
      <div class="col-large-4">
        <div class="cancellation-options">
          <div class="cancellation-options-header">
            <label>Switch to Annual For A Discounted Price</label>
          </div>
          <div class="cancellation-options-body most-popular">
            <div class="insider-most-popular">
              <p class="most-popular-text">MOST POPULAR</p>
            </div>
            <ul class="cancellation-options-list">
              <li>
                Switch to an annual plan and receive your new 1-year
                subscription for ${{ unsubscribe_promo_price }}
              </li>
              <li>${{ price }} for following years</li>
            </ul>
          </div>
          <div class="cancellation-submit">
            <a
              v-bind:class="
                has_used_insider_promo ? 'button-grey' : 'button-green'
              "
              v-on:click="annualSubscription"
            >
              PURCHASE ANNUAL
            </a>
          </div>
        </div>
      </div>
      <div class="col-large-4">
        <div class="cancellation-options">
          <div class="cancellation-options-header">
            <label>Temporarily Pause Your Subscription</label>
          </div>
          <div class="cancellation-options-body">
            <ul class="cancellation-options-list">
              <li>Pause subscription for 30 or 60 days</li>
              <li>You will not be billed while subscription is paused</li>
              <li>
                Regular monthly billing resumes automatically when the paused
                period is over
              </li>
            </ul>
          </div>
          <div class="cancellation-submit">
            <a
              class="button-green button-green-thirty button-margin"
              v-on:click="thirtyDayPause"
            >
              30-DAYS
            </a>
            <a class="button-green button-margin" v-on:click="sixtyDayPause">
              60-DAYS
            </a>
          </div>
        </div>
      </div>
      <div class="col-large-4">
        <div class="cancellation-options">
          <div class="cancellation-options-header">
            <label>Sign up for Free economic updates</label>
          </div>
          <div class="cancellation-options-body">
            <ul class="cancellation-options-list">
              <li>Unsubscribe from Insider subscription</li>
              <li>
                Sign up for email updates on the latest economic trends,
                important insights, upcoming webinars, and more
              </li>
            </ul>
            <div class="insider-cancellation-checkbox">
              <input
                type="checkbox"
                id="i-agree-checkbox"
                class="insider-cancellation-checkbox-input"
                v-model="iAgreeChecked"
              />
              <label
                for="i-agree-checkbox"
                class="insider-cancellation-checkbox-label"
              >
                I agree to receive other communications from ITR Economics.
                <img
                  src="/images/question-mark-gray.png"
                  class="img-fluid"
                  title="ITR Economics is committed to protecting your privacy. Please review our privacy policy to learn more. By checking this box, you consent to our contacting you and to our storing and processing the personal information you have entered above."
                />
              </label>
            </div>
          </div>
          <div class="cancellation-submit">
            <a
              v-bind:class="iAgreeChecked ? 'button-green' : 'button-grey'"
              v-on:click="updatesSignUp"
            >
              SIGN UP
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  export default {
    name: 'InsiderCancellationOptionsComponent',
    props: {
      product_to_unsubscribe: String,
      unsubscribe_promo_price: String,
      price: String,
      has_used_insider_promo: Boolean,
    },
    data: function () {
      return {
        iAgreeChecked: false,
      };
    },
    methods: {
      annualSubscription: function () {
        if (!this.has_used_insider_promo) {
          axios
            .post('/dashboard/cancelation/options/insider')
            .then(function (response) {
              window.location.href = '/dashboard/insider-annual-subscription/';
            })
            .catch(function (error) {
              window.location.href = '/dashboard/contact-customer-care-error/';
            });
        }
      },
      thirtyDayPause: function () {
        axios
          .post(
            '/dashboard/cancelation/options/pause/' +
              this.product_to_unsubscribe +
              '/' +
              30
          )
          .then(function (response) {
            window.location.href =
              '/dashboard/cancelation/options/pause/insider/30';
          })
          .catch(function (error) {
            window.location.href = '/dashboard/contact-customer-care-error/';
          });
      },
      sixtyDayPause: function () {
        axios
          .post(
            '/dashboard/cancelation/options/pause/' +
              this.product_to_unsubscribe +
              '/' +
              60
          )
          .then(function (response) {
            window.location.href =
              '/dashboard/cancelation/options/pause/insider/60';
          })
          .catch(function (error) {
            window.location.href = '/dashboard/contact-customer-care-error/';
          });
      },
      updatesSignUp: function () {
        if (this.iAgreeChecked) {
          axios
            .post('/dashboard/unsubscribe/' + this.product_to_unsubscribe)
            .then(function (response) {
              window.location.href = '/dashboard/newsletter-signup';
            })
            .catch(function (error) {
              window.location.href = '/dashboard/contact-customer-care-error/';
            });
        }
      },
    },
  };
</script>
